import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
// eslint-disable-next-line import/no-unassigned-import
import "@faire/retailer-visitor-shared/components/slick.css";
import { EyebrowText } from "@faire/retailer-visitor-shared/components/TestimonialsCardSection/common";
import { TestimonialCard } from "@faire/retailer-visitor-shared/components/TestimonialsCardSection/TestimonialsCard";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackInsiderLoggedOutMarketingPageTestimonialsView } from "@faire/web-api--source/events/insider/view/loggedOutMarketingPageTestimonials";
import React from "react";
import Slider from "react-slick";
import styled, { css } from "styled-components";
export var TestimonialsCardSection = function(param) {
    var testimonials = param.testimonials, title = param.title, backgroundColor = param.backgroundColor, textColor = param.textColor, textStyle = param.textStyle, titleColor = param.titleColor;
    var viewport = useViewport();
    var sliderRef = React.useRef(null);
    var ref = useDoActionWhenVisible(function() {
        trackInsiderLoggedOutMarketingPageTestimonialsView();
    });
    return /*#__PURE__*/ _jsxs(Section, {
        $withVerticalPadding: true,
        $backgroundColor: backgroundColor,
        ref: ref,
        children: [
            viewport.isMobile ? /*#__PURE__*/ _jsxs(HorizontalPaddingWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(EyebrowText, {
                        $color: titleColor ? titleColor : textColor,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "4x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Slider, {
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                pauseOnHover: true,
                ref: sliderRef,
                children: testimonials.map(function(testimonial) {
                    return /*#__PURE__*/ _jsx(HorizontalPaddingWrapper, {
                        children: /*#__PURE__*/ _jsx(TestimonialCard, {
                            testimonial: testimonial,
                            title: title,
                            textColor: textColor,
                            textStyle: textStyle,
                            titleColor: titleColor
                        })
                    }, testimonial.name);
                })
            }),
            viewport.isTabletAndAbove && testimonials.length > 1 ? /*#__PURE__*/ _jsxs(ArrowsWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(ArrowComponent, {
                        direction: "left",
                        onClick: function() {
                            var _sliderRef_current;
                            return (_sliderRef_current = sliderRef.current) === null || _sliderRef_current === void 0 ? void 0 : _sliderRef_current.slickPrev();
                        }
                    }),
                    /*#__PURE__*/ _jsx(ArrowComponent, {
                        direction: "right",
                        onClick: function() {
                            var _sliderRef_current;
                            return (_sliderRef_current = sliderRef.current) === null || _sliderRef_current === void 0 ? void 0 : _sliderRef_current.slickNext();
                        }
                    })
                ]
            }) : null
        ]
    });
};
var ArrowComponent = function(param) {
    var direction = param.direction, onClick = param.onClick;
    var marginValue = useResponsiveValue({
        mobileAndAbove: 0,
        tabletAndAbove: -40,
        desktopAndAbove: -60,
        xLargeAndAbove: -70
    });
    return /*#__PURE__*/ _jsx(ArrowWrapper, {
        onClick: onClick,
        $arrowDirection: direction,
        $marginValue: marginValue,
        align: "center",
        justify: "center",
        children: /*#__PURE__*/ _jsx(Arrow, {
            direction: direction
        })
    });
};
var ArrowWrapper = styled(Row).withConfig({
    componentId: "sc-32f2af8c-0"
})([
    "pointer-events:auto;border:1px solid ",
    ";background-color:",
    ";width:35px;height:35px;border-radius:35px;",
    "{",
    "}",
    "{",
    "}",
    "{",
    "}",
    "{",
    "}"
], Core.border.muted, Core.surface.inverse, responsiveMediaQueries.mobile, function(props) {
    return css([
        "margin-",
        ":0px"
    ], props.$arrowDirection);
}, responsiveMediaQueries.tablet, function(props) {
    return css([
        "margin-",
        ":-50px"
    ], props.$arrowDirection);
}, responsiveMediaQueries.desktop, function(props) {
    return css([
        "margin-",
        ":-70px"
    ], props.$arrowDirection);
}, responsiveMediaQueries.xLargeAndAbove, function(props) {
    return css([
        "margin-",
        ":-80px"
    ], props.$arrowDirection);
});
var horizontalPadding = css([
    "padding-left:32px;padding-right:32px;",
    "{padding-left:72px;padding-right:72px;}",
    "{padding-left:128px;padding-right:128px;}",
    "{padding-left:208px;padding-right:208px;}",
    "{padding-left:184px;padding-right:184px;}"
], responsiveMediaQueries.tablet, responsiveMediaQueries.desktop, responsiveMediaQueries.xlarge, responsiveMediaQueries.xxlarge);
var verticalPadding = css([
    "padding-top:48px;padding-bottom:48px;",
    "{padding-top:72px;padding-bottom:72px;}",
    "{padding-top:128px;padding-bottom:128px;}"
], responsiveMediaQueries.tablet, responsiveMediaQueries.desktopAndAbove);
var Section = styled(Column).attrs({
    as: "section"
}).withConfig({
    componentId: "sc-32f2af8c-1"
})([
    "position:relative;",
    " ",
    " ",
    ""
], function(props) {
    return props.$backgroundColor ? css([
        "background-color:",
        ";"
    ], props.$backgroundColor) : "";
}, function(props) {
    return props.$withHorizontalPadding ? horizontalPadding : "";
}, function(props) {
    return props.$withVerticalPadding ? verticalPadding : "";
});
var HorizontalPaddingWrapper = styled.div.withConfig({
    componentId: "sc-32f2af8c-2"
})([
    "",
    ""
], horizontalPadding);
var ArrowsWrapper = styled(Row).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-32f2af8c-3"
})([
    "position:absolute;top:50%;transform:translateY(-50%);width:100%;pointer-events:none;",
    ""
], horizontalPadding);
